import { c as _c } from "react/compiler-runtime";
import { FileIcon } from '@/components/DetailedView/icons/FileIcon';
import { SaveIcon } from '@/components/DetailedView/icons/SaveIcon';
import { downloadFile, generateCsv, generateJson, generateXml } from '@/components/DetailedView/utils/files';
import { type Metric } from '@/types';
import { Popover, PopoverArrow, PopoverContent, PopoverTrigger } from '@tallinn-arvudes/ui/atoms/popover';
import { type ParsedChartReturn } from '@tallinn-arvudes/ui/chart/types';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { useEffect, useState, type RefObject } from 'react';
export const Download = t0 => {
  const $ = _c(32);
  const {
    metric,
    parsedMetric,
    containerRef
  } = t0;
  const [container, setContainer] = useState(null);
  let t1;
  if ($[0] !== containerRef?.current) {
    t1 = () => {
      setContainer(containerRef?.current ?? null);
    };
    $[0] = containerRef?.current;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== containerRef) {
    t2 = [containerRef];
    $[2] = containerRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PopoverTrigger asChild={true}><Button compact={true} variant="icon" tooltip="Lae alla" className="text-semantic-content-faint"><SaveIcon className="!w-5 lg:!w-6 !h-5 lg:!h-6" /></Button></PopoverTrigger>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-semantic-content-brand text-lg mx-2 mb-1">Laadi alla</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== metric.titlePlainText || $[7] !== parsedMetric) {
    t5 = () => {
      const csv = generateCsv(parsedMetric);
      downloadFile(csv, `${metric.titlePlainText}.csv`, "text/csv");
    };
    $[6] = metric.titlePlainText;
    $[7] = parsedMetric;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FileIcon />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <Button compact={true} variant="secondary-neutral" className="text-xs border-transparent hover:!bg-white/60 hover:!border-white/60 hover:!text-semantic-content-brand" onClick={t5} tooltip="Lae alla CSV failina" icon={t6} iconPosition="left">.CSV</Button>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== metric || $[13] !== parsedMetric) {
    t8 = () => {
      const xml = generateXml(metric, parsedMetric);
      downloadFile(xml, `${metric.titlePlainText}.xml`, "text/xml");
    };
    $[12] = metric;
    $[13] = parsedMetric;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FileIcon />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8) {
    t10 = <Button compact={true} variant="secondary-neutral" className="text-xs border-transparent hover:!bg-white/60 hover:!border-white/60 hover:!text-semantic-content-brand" onClick={t8} tooltip="Lae alla XML failina" icon={t9} iconPosition="left">.XML</Button>;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== metric || $[19] !== parsedMetric) {
    t11 = () => {
      const json = generateJson(metric, parsedMetric);
      downloadFile(json, `${metric.titlePlainText}.json`, "application/json");
    };
    $[18] = metric;
    $[19] = parsedMetric;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FileIcon />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = <Button compact={true} variant="secondary-neutral" className="text-xs border-transparent hover:!bg-white/60 hover:!border-white/60 hover:!text-semantic-content-brand" onClick={t11} tooltip="Lae alla JSON failina" icon={t12} iconPosition="left">.JSON</Button>;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t7) {
    t14 = <div className="flex flex-col items-start gap-1">{t4}{t7}{t10}{t13}</div>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t7;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <PopoverArrow height={15} width={15} className="fill-semantic-surface-faint" />;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== container || $[30] !== t14) {
    t16 = <Popover>{t3}<PopoverContent container={container} sideOffset={-5} onEscapeKeyDown={_temp} className="w-32 bg-semantic-surface-faint shadow-md border-none flex flex-col px-2" align="end">{t14}{t15}</PopoverContent></Popover>;
    $[29] = container;
    $[30] = t14;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};
function _temp(e) {
  e.stopPropagation();
}